import React, { useEffect, useRef, useState, useContext } from 'react';
import SubStrategyList from './components/sub-strategy-list';
import CategoryInventoryList from './components/category-inventory-list';
import { getQuery } from '@/common/utils';
import CardWarp from '@/components/card-warp';
import apis from '@/apis/goodsPool';
import HpAlert from './components/hp-alert';
import './index.less';
import { getRootPath } from '@/pages/platform-marketing-position/resource-detail/util';
import { newPandoraLink, newPandoraConfig } from '@/micro-app/context/new-pandora-config';
import contextProviderMenus from '@/components/slide-menu/provide-slide-menu';

function CategoryHp(props) {
  //activityType : 'channel'//频道活动 ,'daily':日常活动, 'theme':主题活动
  const { activityId, activityType } = props;
  const [data, setData] = useState({ isShow: false });
  const [isShow, setIsShow] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const subRef = useRef(null);
  const tabRef = useRef(null);
  const channelId = getQuery('channelId');
  const poolIDSInNew = useContext(newPandoraConfig);
  const { ruleIdRef } = useContext(contextProviderMenus);

  const log_sense_id = {
    channel: 2,
    daily: 0,
    theme: 1,
  };

  const goSetRule = () => {
    activityType === 'channel' &&
      window.open(
        `/channel-service/position/${channelId}/material-poolrule-new?planCode=${channelId}#/integration/threshold`
      );
  };

  const goSelect = (subRule = [], hpInfo) => {
    const roomId = getQuery('roomId'),
      blockId = getQuery('blockId');
    const activityId = getQuery('activityId');

    const resourceId = getQuery('resourceId');
    const planCode = getQuery('planCode');

    let defaultRules = [];
    if (hpInfo.length) {
      defaultRules.push({
        ruleCode: 'taskId',
        ruleName: '商品策略',
        value: hpInfo.map((item) => {
          return { value: item.inventoryId, label: item.inventoryName };
        }),
      });
    }
    defaultRules.push({
      ruleCode: 'ruleGroupId',
      ruleName: '子策略',
      value: subRule.map((item) => {
        return { value: item.subStrategyId, label: item.subStrategyName };
      }),
    });

    let link = '';
    if (activityType === 'channel') {
      const oldLink = `/pandoraacore/#/integration/manage/121?jumpTo=SCSC&outId=${channelId}&resourceId=${resourceId}&yxActivityId=${activityId}&activityType=9&defaultRules=${JSON.stringify(
        defaultRules
      )}&platformChannelType=${getRootPath() === 'platform-marketing' ? 1 : 2}`;
      const newLink = `/selection/#/selection/manage/121?thresholdRuleId=${
        ruleIdRef.current
      }&jumpTo=SCSC&outId=${channelId}&resourceId=${resourceId}&yxActivityId=${activityId}&activityType=9&defaultRules=${JSON.stringify(
        defaultRules
      )}&platformChannelType=${getRootPath() === 'platform-marketing' ? 1 : 2}`;

      link = newPandoraLink(121, poolIDSInNew, oldLink, newLink);
    } else if (activityType === 'daily') {
      const oldLink = `/pandoraacore/#/integration/manage/121?jumpTo=WDSC&outId=${roomId}&resourceId=${blockId}&activityType=11&defaultRules=${JSON.stringify(
        defaultRules
      )}&yxActivityId=${activityId}`;
      const newLink = `/selection/#/selection/manage/121?thresholdRuleId=${
        ruleIdRef.current
      }&jumpTo=WDSC&outId=${roomId}&resourceId=${blockId}&activityType=11&defaultRules=${JSON.stringify(
        defaultRules
      )}&yxActivityId=${activityId}`;

      link = newPandoraLink(121, poolIDSInNew, oldLink, newLink);
    } else if (activityType === 'theme') {
      const oldLink = `/pandora/#/integration/manage/${planCode}/121?jumpTo=TESC&activityType=9&defaultRules=${JSON.stringify(
        defaultRules
      )}`;
      const newLink = (oldLink = `/selection/#/selection/manage/${planCode}/121?thresholdRuleId=${
        ruleIdRef.current
      }&jumpTo=TESC&activityType=9&defaultRules=${JSON.stringify(defaultRules)}`);

      link = newPandoraLink(121, poolIDSInNew, oldLink, newLink);
    }
    window.open(link);
  };

  const refreshBlock = () => {
    setRefresh((val) => val + 1);
    subRef.current.refresh();
    tabRef.current.refresh();
  };

  // 先查展示
  useEffect(() => {
    if (!activityId) return;
    apis
      .getInventoryStatus({ activityId, onlyShow: true })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg;
        setIsShow(data.isShow);
      })
      .catch((ex) => {
        message.error(ex || '货盘状态获取失败！');
      });
  }, [activityId]);

  // 再查别的字段
  useEffect(() => {
    if (!activityId || !isShow) return;

    apis
      .getInventoryStatus({ activityId })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg;
        setData(data);
      })
      .catch((ex) => {
        message.error(ex || '货盘状态获取失败！');
      });
  }, [activityId, refresh, isShow]);

  return isShow ? (
    <CardWarp title="品类货盘">
      {data.isOwner && (
        <HpAlert
          {...data}
          activityId={activityId}
          refreshBlock={refreshBlock}
          goSetRule={goSetRule}
          log_sense_id={log_sense_id[activityType]}
        />
      )}
      <SubStrategyList activityId={activityId} ref={subRef} goSelect={goSelect} />
      <CategoryInventoryList
        dataForAlert={data}
        activityId={activityId}
        ref={tabRef}
        goSelect={goSelect}
        isOwner={data.isOwner}
        refreshBlock={refreshBlock}
        log_sense_id={log_sense_id[activityType]}
      />
    </CardWarp>
  ) : null;
}

CategoryHp.CHANNEL = 'channel';
CategoryHp.DAILY = 'daily';
CategoryHp.THEME = 'theme';

export default CategoryHp;
